import React from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { Flex, Loading as LoadingSpinner } from '@ui/wrapper';

const LoadingWrapper = styled(Flex)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: ${themeGet('zIndices.godLevel')};
`;

const Loading = () => (
  <LoadingWrapper
    data-testid="loading-page"
    justifyContent="center"
    alignItems="center"
  >
    <LoadingSpinner />
  </LoadingWrapper>
);

export { Loading };
